import { Card } from "@/components/ui/card";

export const EventsList = () => {
  return (
    <Card className="p-6">
      <h3 className="text-lg font-semibold mb-4">Events</h3>
      <p className="text-muted-foreground">Events list will appear here.</p>
    </Card>
  );
};